/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pushDialog.vue?vue&type=template&id=b80fe6c0&scoped=true&"
import script from "./pushDialog.vue?vue&type=script&lang=ts&"
export * from "./pushDialog.vue?vue&type=script&lang=ts&"
import style0 from "./pushDialog.vue?vue&type=style&index=0&id=b80fe6c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80fe6c0",
  null
  
)

export default component.exports